import { driverDto } from "../dtos/driverDto";
import { Driver } from "../models/driver";
import RoutingApiService from "../services/routingApi";

export const fetchDrivers = async (): Promise<Driver[]> => {
    const apiService = new RoutingApiService();
    
    try {
        const response = await apiService.get<any>(`/fleets/drivers/rio`);
        if (response.status === 200) {
            return response.data.data?.result?.drivers
                ?.filter((driver: any) => driver.uniqueProfileId)
                .map(driverDto);
        } else return [];
    } catch (error) {
        console.error(error);
        return [];
    }
}